import { ol_Extent, ol_source, ol_layer } from "@omnia/exports/openlayers"
import { BasemapKey, IBasemap } from "../types"

export class Basemap implements IBasemap {

    private source: ol_source.Source

    constructor(
        public readonly name: string,
        private readonly layer: ol_layer.Layer,
        private readonly sourceFactory: () => ol_source.Source,
        private readonly extent?: ol_Extent,
        public readonly key?: BasemapKey) {
    }

    private getSource(create: boolean) {

        if (create && (this.source == null)) {

            if (this.sourceFactory) {
                this.source = this.sourceFactory()
            }

        }

        return this.source
    }

    setActive(active: boolean) {

        if (!active) {
            this.layer.setVisible(false)
            return
        }

        let olsrc = this.getSource(true)

        if (!olsrc) {
            this.layer.setVisible(false)
        }
        else {
            this.layer.setSource(olsrc)
            this.layer.setVisible(true)
        }

    }

    getExtent() {
        return this.extent
    }

}
